import cardData from '../data/gridcards';

const getCardData = (cardId = false) => {

    return cardData.map((card, i) => {
        const setSelected = (cardId !== false && cardId === i) ? true : (cardId === false && i === 0) ? true : false;
        return Object.assign({}, card, {
            selected: setSelected,
        });
    });
};

const initialState = {
    cards: getCardData(),
    image: cardData[0].image,
    title: cardData[0].title,
    firstcopy: cardData[0].firstcopy,
    italics: cardData[0].italics,
    endcopy: cardData[0].endcopy,
};

const leadTheWay = (state = initialState, action) => {

    switch (action.type) {
        case "LEADTHEWAY_UPDATE":
            return Object.assign({}, state, {
                cards: getCardData(action.id),
                image: action.image,
                title: action.title,
                firstcopy: action.firstcopy,
                italics: action.italics,
                endcopy: action.endcopy,
            });
        default:
            return state;
    }
};

export default leadTheWay;



// WEBPACK FOOTER //
// ./src/reducers/leadTheWay.js